/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface BarLicense
 */
export interface BarLicense {
    /**
     * 
     * @type {string}
     * @memberof BarLicense
     */
    jurisdictionId?: string;
    /**
     * 
     * @type {string}
     * @memberof BarLicense
     */
    barNumber?: string | null;
}

export function BarLicenseFromJSON(json: any): BarLicense {
    return BarLicenseFromJSONTyped(json, false);
}

export function BarLicenseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BarLicense {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'jurisdictionId': !exists(json, 'jurisdictionId') ? undefined : json['jurisdictionId'],
        'barNumber': !exists(json, 'barNumber') ? undefined : json['barNumber'],
    };
}

export function BarLicenseToJSON(value?: BarLicense | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'jurisdictionId': value.jurisdictionId,
        'barNumber': value.barNumber,
    };
}


